import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { LeaguePlayer } from '../models/league-player';
import { map } from 'rxjs/operators';
import { TournamentTeamUser } from '../models/tournament-team-user';

@Injectable({providedIn: 'root'})
export class LeaguePlayerApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getById(leaguePlayerId: number): Promise<LeaguePlayer> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_player/${leaguePlayerId}/`).pipe(
      map(item => LeaguePlayer.toFront(item))
    ).toPromise();
  }

  getTournamentUsers(leaguePlayerId: number, seasonId?: number): Promise<TournamentTeamUser[]> {
    let params = new HttpParams();
    if (seasonId) {
      params = params.set('season_id', seasonId.toString());
    }
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_player/${leaguePlayerId}/tournament_users/`, {params}).pipe(
      map(item => TournamentTeamUser.toFront(item))
    ).toPromise();
  }
}
